module.exports = __webpack_public_path__ + "img/QC.656da757.svg";